import { render } from "./Province.vue?vue&type=template&id=f301a226&scoped=true&ts=true"
import script from "./Province.ts?vue&type=script&lang=ts"
export * from "./Province.ts?vue&type=script&lang=ts"

import "./Province.scss?vue&type=style&index=0&id=f301a226&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f301a226"]])

export default __exports__